import React from 'react';
import Loading from '@/common/components/Loading';
import CallAnalysisDetail from './components/CallAnalysisDetail';
import CallAnalysisSearchBar from './components/CallAnalysisSearchBar';
import CallAnalysisTable from './components/callAnalysisTable/CallAnalysisTable';
import useCallAnalysis from './hooks/useCallAnalysis';
import { Wrapper } from './callAnalysis.styles';

const CallAnalysis = () => {
	const {
		items,
		total,
		page,
		totalPages,
		selectedAnalysis,
		setSelectedAnalysis,
		consultants,
		managers,
		marketsOptions,
		formik,
		isLoading,
		handleOpenOrAnalyze,
		handleAnalyzeMissing,
		goToPage,
		handleAnalysisUpdated,
	} = useCallAnalysis();

	return (
		<>
			{isLoading && <Loading />}
			<Wrapper>
				<CallAnalysisSearchBar
					formik={formik}
					consultants={consultants}
					managers={managers}
					marketsOptions={marketsOptions}
				/>
				<CallAnalysisTable
					items={items}
					total={total}
					page={page}
					totalPages={totalPages}
					onOpen={handleOpenOrAnalyze}
					onAnalyze={handleAnalyzeMissing}
					onPageChange={goToPage}
				/>
			</Wrapper>

			{selectedAnalysis && (
				<CallAnalysisDetail
					analysis={selectedAnalysis}
					setShow={setSelectedAnalysis}
					onUpdated={handleAnalysisUpdated}
				/>
			)}
		</>
	);
};

export default CallAnalysis;
